import usePost from '@/core/composables/api/usePost'
import { ApiRequestStatus } from '@/core/models/api/api-request-status'
import { resolveRedirect } from '@/core/utils/resolve-redirect'
import { useOrganizationStore } from '@/stores/organization.store'
import { computed, ref } from 'vue'
import { useRouter } from 'vue-router'

export const useJoinOrganization = () => {
  const router = useRouter()
  const organizationStore = useOrganizationStore()
  const acceptStatus = ref(ApiRequestStatus.Idle)

  const organization = computed(() => organizationStore.currentOrganization)

  const acceptOrganization = async () => {
    const orgId = organizationStore.currentOrganizationId
    const { mutate, status } = usePost(`organizations/${orgId}/accept`, true)

    await mutate()
    acceptStatus.value = status.value

    if (status.value === ApiRequestStatus.Success) {
      await organizationStore.initializeOrganizations()
      await router.push(resolveRedirect(router.currentRoute.value.query.redirect))
    }
  }

  return { organization, acceptStatus, acceptOrganization }
}
